<template>
    <div class="row table-wrapper">
        <div v-show="isGenerating">
            <ring-loader></ring-loader>
        </div>
        <div v-show="isEnd && mealsToRender.length <= 0" style="margin-top: 20px; padding-left: 20px; font-weight: bold;">
            BRAK ZAPLANOWANYCH POSIŁKÓW W TYM ZAKRESIE DAT
        </div>
        <div v-show="!isEnd && mealsToRender.length > 0" class="progress" style="margin: 20px 0;">
            <div
                class="progress-bar"
                role="progressbar"
                :aria-valuenow="currentProgress"
                aria-valuemin="0"
                :aria-valuemax="length"
                :style="{ width: currentProgress + '%' }"
            >
                <span class="sr-only">{{ currentProgress }}% Complete</span>
            </div>
        </div>
        <table v-show="isEnd && mealsToRender.length > 0 && !isGenerating" id="table">
            <thead>
                <tr>
                    <th rowspan="2">Id posiłku</th>
                    <th rowspan="2">Nazwa posiłku</th>
                    <th rowspan="2">Wariant</th>
                    <th rowspan="2">Wielkość</th>
                    <th rowspan="2">Liczba ocen</th>
                    <th rowspan="2">Ocena ogólna</th>
                    <th rowspan="2">Ocena z ostatnich 3-ech miesięcy</th>
                    <th colspan="2">Miesiąc zrobienia raportu</th>
                    <th colspan="2">Miesiąc zrobienia raportu -1</th>
                    <th colspan="2">Miesiąc zrobienia raportu -2</th>
                    <th rowspan="2">Ile razy posiłek był użyty w ciągu ostatnich 12 m-scy?</th>
                    <th rowspan="2">Ile zdjęć na porcji</th>
                    <th rowspan="2">Data dodania zdjęcia</th>
                    <th rowspan="2">Link do zdjęcia</th>
                    <th rowspan="2">Składniki posiłku</th>
                    <th rowspan="2">Alergeny</th>
                </tr>
                <tr>
                    <th>Średnia ocen</th>
                    <th>Liczba osób oceniających</th>
                    <th>Średnia ocen</th>
                    <th>Liczba osób oceniających</th>
                    <th>Średnia ocen</th>
                    <th>Liczba osób oceniających</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(record, index) in mealsToRender" :key="index">
                    <td>{{ record.serving.meal.id }}</td>
                    <td>{{ record.serving.meal.name }}</td>
                    <td>{{ record.variant.name }}</td>
                    <td>{{ record.basketMeal.size.name }}</td>
                    <td>{{ record.serving.meal.rateCount }}</td>
                    <td>
                      {{ record.serving.meal.rateCount == 0 ? 0 :
                        (record.serving.meal.rateSum / record.serving.meal.rateCount).toFixed(2)
                      }}
                    </td>
                    <td><last-three-months-rating :meal-id="record.serving.meal.id"/></td>
                    <td>
                      <rate-for-month
                          :count="false"
                          :month="getMonth(0)"
                          :year="getYear(0)"
                          :meal-id="record.serving.meal.id"
                          :index="index"
                          @loadingFinished="finishedLoading"
                      />
                    </td>
                    <td>
                      <rate-for-month
                          :count="true"
                          :month="getMonth(0)"
                          :year="getYear(0)"
                          :meal-id="record.serving.meal.id"
                          :index="index"
                          @loadingFinished="finishedLoading"
                      />
                    </td>
                    <td>
                      <rate-for-month
                          :count="false"
                          :month="getMonth(1)"
                          :year="getYear(1)"
                          :meal-id="record.serving.meal.id"
                          :index="index"
                          @loadingFinished="finishedLoading"
                      />
                    </td>
                    <td>
                      <rate-for-month
                          :count="true" :month="getMonth(1)"
                          :year="getYear(1)"
                          :meal-id="record.serving.meal.id"
                          :index="index"
                          @loadingFinished="finishedLoading"
                      />
                    </td>
                    <td>
                      <rate-for-month
                        :count="false"
                        :month="getMonth(2)"
                        :year="getYear(2)"
                        :meal-id="record.serving.meal.id"
                        :index="index"
                        @loadingFinished="finishedLoading"
                      />
                    </td>
                    <td>
                      <rate-for-month
                          :count="true"
                          :month="getMonth(2)"
                          :year="getYear(2)"
                          :meal-id="record.serving.meal.id"
                          :index="index"
                          @loadingFinished="finishedLoading"
                      />
                    </td>
                    <td><last-year-usage :meal-id="record.serving.meal.id" /></td>
                    <td>{{ record.serving.photos.length }}</td>
                    <td>{{ getLastPhoto(record.serving.photos).createdAt }}</td>
                    <td>
                        {{
                            getLastPhoto(record.serving.photos).file ?
                            'https://dccore.ntfy.pl/upload/multimedia/' + getLastPhoto(record.serving.photos).file :
                            ''
                        }}
                    </td>
                    <td>{{ record.serving.stringAllMaterials }}</td>
                    <td>{{ record.serving.meal.stringAllergens }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import lastThreeMonthsRating from './ratingReport/lastThreeMonthsRating.vue'
import rateForMonth from './ratingReport/rateForMonth.vue'
import lastYearUsage from './ratingReport/lastYearUsage.vue'
import RingLoader from 'vue-spinner/src/RingLoader.vue'

export default {
  components: {
    lastThreeMonthsRating,
    rateForMonth,
    RingLoader,
    lastYearUsage
  },
  props: {
    meals: {
      type: [Object, Array],
      required: true,
    },
    isGenerating: {
      type: Boolean,
      default: true,
    },
    isGenerated: {
      type: Boolean,
      default: false,
    },
    length: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      month: this.getFormattedCurrentMonth(),
      rowCounter: {},
      mealsToRender: [],
      isEnd: false,
      jsonTable: [],
      groupedData: []
    }
  },
  computed: {
    filteredMealsToRender() {
      return this.mealsToRender.filter((meal, index) => index === 0 || this.rowCounter[index - 1] === 6)
    },
    currentProgress: function () {
      if (Number(this.length) === 0) {
        return 0
      }
      if (this.isEnd) {
        return 100
      } else {
        return ((this.mealsToRender.length - 1) / this.length) * 100
      }
    }
  },
  watch: {
    meals: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.finishedLoading()
      }
      if (this.meals.length > 0) {
        this.isEnd = false
      }
    },
    isEnd: function (newValue) {
      if (newValue) {
        this.tableToJson()
      }
    }
  },
  created() {
    this.loading++
  },
  methods: {
    getLastPhoto(photos) {
      let tmpPhotos = JSON.parse(JSON.stringify(photos))
      return tmpPhotos.length > 0 ?
        (tmpPhotos.sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()))[tmpPhotos.length - 1] :
        ''
    },
    getFormattedCurrentMonth() {
      return ((new Date()).getMonth()) + 1
    },
    finishedLoading() {
      if (this.meals.length > 0) {
        let tmp = [].concat(this.mealsToRender)
        // eslint-disable-next-line vue/no-mutating-props
        tmp.push(this.meals.shift())
        this.mealsToRender = tmp
      } else {
        this.isEnd = true
      }
    },
    getYear(modificator) {
      if ((this.getFormattedCurrentMonth() === 1 && modificator in [1, 2]) ||
          (this.getFormattedCurrentMonth() === 2 && modificator === 2)
      ) {
        return ((new Date()).getFullYear()) - 1
      }
      return (new Date()).getFullYear()
    },
    getMonth(modificator) {
      let month = this.getFormattedCurrentMonth()
      if ((month > 2) || (month === 2 && modificator === 1)) {
        return month - modificator
      }
      if (month === modificator) {
        return 12
      }
      if (month === 1 && modificator === 2) {
        return 11
      }
      return month
    },
    resetState() {
      this.mealsToRender = []
      this.rowCounter = {}
      this.isEnd = false
      this.groupedData = []
    },
    tableToJson() {
      var data = []
      var headers = []
      let table = document.getElementById('table')
      if (table) {
        headers = [
          'Id posiłku',
          'Nazwa posiłku',
          'Wariant',
          'Wielkość',
          'Liczba ocen',
          'Ocena ogólna',
          'Ocena z ostatnich 3-ech miesięcy',
          'Średnia ocen',
          'Liczba osób oceniających',
          'Średnia ocen - 1',
          'Liczba osób oceniających - 1',
          'Średnia ocen - 2',
          'Liczba osób oceniających - 2',
          'Ile razy posiłek był użyty w ciągu ostatnich 12 m-scy?',
          'Ile zdjęć na porcji',
          'Data dodania zdjęcia',
          'Link do zdjęcia',
          'Składniki posiłku',
          'Alergeny'
        ]
        for (var i = 2; i < table.rows.length; i++) {
          var tableRow = table.rows[i]
          var rowData = {}

          for (var j = 0; j < tableRow.cells.length; j++) {
            rowData[ headers[j] ] = tableRow.cells[j].innerHTML.replace(/<(?:.|\n)*?>/gm, '').replace('.', ',').toString()
          }

          data.push(rowData)
        }
        this.jsonTable = data
      }
    }
  },
}
</script>

<style scoped>
table {
  border-collapse: collapse;
  margin-top: 20px;
}

table, th, td {
  border: 1px solid black;
  padding: 5px;
}
.table-wrapper {
    overflow-x: auto;
}
</style>
